import { useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { classNames, useIsMounted } from "@ct-react/core";
import Button from "../common/button";
import "./rooms.scss";

const transDefs = defineMessages({
  all: { id: "components.inputs.rooms.all", defaultMessage: "Tout" }
});

type Props = {
  className?: string;
  max?: number;
  value?: number;
  onChange?: (value?: number) => void;
}

const RoomsInput = ({ className, max = 10, value, onChange = () => void 0 }: Props) => {

  const isMounted = useIsMounted();
  const intl = useIntl();

  const [ edition, setEdition ] = useState<number | undefined>(!!value ? Math.min(value, max) : value);

  useEffect(() => {
    if (!isMounted) return;
    setEdition(!!value ? Math.min(value, max) : value);
  }, [ value ]);

  useEffect(() => {
    if (!isMounted) return;
    onChange(edition);
  }, [edition ]);

  const wrapperClasses = classNames("rooms-input", className);

  return (
    <div className={wrapperClasses}>
      <div className="scrollable-wrap">
        <Button type="button"
                className={classNames("all item", { selected: !edition })}
                onClick={() => setEdition(undefined)}>
          {intl.formatMessage(transDefs.all)}
        </Button>
        {Array.from({ length: max }).map((_, index) =>
          <Button key={index}
                  type="button"
                  className={classNames("item", { selected: edition === index + 1 })}
                  onClick={() => setEdition(index + 1)}>
            {`${index + 1}+`}
          </Button>
        )}
      </div>
    </div>);

};

export default RoomsInput;
